import { apiService } from './api.services.js'

export function goRequestKey() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID()
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')
}

export async function goApi(path, method = 'GET', payload) {
  const data = await apiService(path, method, payload)
  if (!data || data.err || data.detail) throw new Error((data && (data.err || data.detail)) || 'No pudimos cargar FOMO GO.')
  return data
}

export function goMoney(amount, currency) {
  return new Intl.NumberFormat('es', { style: 'currency', currency, currencyDisplay: 'code' }).format(Number(amount))
}
